import React from "react";

// All pages that rely on 3rd party components (other than Bootstrap) are
// loaded asynchronously, to keep the initial JS bundle to a minimum size

// Layouts
import AuthLayout from "./layouts/Auth";
import DashboardLayout from "./layouts/Dashboard";

// Guards
import AuthGuard from "./components/guards/AuthGuard";

// Auth
import Page404 from "./pages/auth/Page404";

//Taps
import Taps from "./pages/taps/Taps";

// SQL Editor with v1/v2 toggle
import EditorToggle from "./pages/sql/EditorToggle";

//Jobs
import Overview from "./pages/jobs/Overview";
import Push from "./pages/jobs/Push";
import Observability from "./pages/observability";

// CRM
import { Campaigns, CampaignWizard, CampaignDetails } from "./pages/sms";
import InboxPage from "./pages/crm-v2/InboxPage";

// Code Environment
import Code from "./pages/Code";

// Protected routes
import ProtectedPage from "./pages/protected/ProtectedPage";

const routes = [
  {
    path: "taps",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "mytaps",
        element: <Taps />,
      },
    ],
  },
  {
    path: "sql",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "editor",
        element: <EditorToggle />,
      },
    ],
  },
  {
    path: "jobs",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "overview",
        element: <Overview />,
      },
      {
        path: "push",
        element: <Push />,
      },
    ],
  },
  {
    path: "observability",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Observability />,
      },
    ],
  },
  {
    path: "crm",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Campaigns />,
      },
      {
        path: "campaigns",
        element: <Campaigns />,
      },
      {
        path: "campaigns/:id",
        element: <CampaignDetails />,
      },
      {
        path: "new",
        element: <CampaignWizard />,
      },
{
        path: "inbox",
        element: <InboxPage />,
      },
    ],
  },
  {
    path: "code",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Code />,
      },
    ],
  },
  {
    path: "",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <ProtectedPage />,
      },
    ],
  },
  {
    path: "*",
    element: <AuthLayout />,
    children: [
      {
        path: "*",
        element: <Page404 />,
      },
    ],
  },
];

export default routes;
